/**
 * 公共接口
 */

const { VITE_APP_AFTER } = import.meta.env
const prefix = VITE_APP_AFTER
export default [
  // 添加菜单
  { name: 'increaseMenu', url: `${prefix}/insertWholesalerMenu`, method: 'post' },
]
